import styled from 'styled-components';

const QuestionWrapper = styled('div')`
  &:focus {
    outline: none;
  }
`;

export default QuestionWrapper;
